import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export function authAppInitializerFactory(): Promise<void> {
  const authService = inject(AuthService);

  return authService.isLocalMode()
    ? Promise.resolve()
    : authService.runInitialLoginSequence();
}
